<template>
  <a
    class="geolocation-navbar"
  >
    <c-button
      size="lg"
      icon="map-marker"
    >
      <span v-if="showText">Próximas a você</span>
    </c-button>
  </a>
</template>

<script>
export default {
  props: {
    showText: Boolean
  }
}
</script>

<style lang="scss" scoped>
@import '~@/style/reference';
.geolocation-navbar {
  padding-right: 10px;

  @include mobile {
    padding-right: 0px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Layout/Navbar/GeolocationNavbar.vue